import { Layout } from '../components/Layout/Layout';
import { LogNotes } from '../containers/LogNotes/LogNotes';
import { useTenantNameSubtitle } from '../utils/customHooks/useTenantNameSubtitle';

export const LogNotesPage = () => {
  const tenantNameSubtitle = useTenantNameSubtitle();
  return (
    <Layout
      isMessageLayout
      to="/dashboard"
      message={'logNotes'}
      showBottomTabs
      subMessageText={tenantNameSubtitle}
      subMessageType="accent"
    >
      <LogNotes />
    </Layout>
  );
};
